// Loader.jsx (web)
import { motion } from 'framer-motion'
import { createPortal } from 'react-dom'
import styled, { keyframes } from 'styled-components'

import { LoaderBackdrop, LoaderText, LoaderWrapper } from './Loader.styles.js'

const spin = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
`

export const LoaderSpinner = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top-color: ${({ color }) => color || '#ffffff'};
  animation: ${spin} 0.8s linear infinite;
`

const Loader = ({ color = '#ffffff', text }) => {
  return createPortal(
    <LoaderWrapper
      role="dialog"
      aria-live="polite"
      aria-busy="true"
      as={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <LoaderBackdrop />
      <LoaderSpinner color={color} />
      {text && <LoaderText>{text}</LoaderText>}
    </LoaderWrapper>,
    document.body
  )
}

export default Loader
